var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.multiType)?_c('div',{staticClass:"omit"},[_vm._v("...")]):_c('div',{staticClass:"fz-12"},[_vm._v(" \n\t\t"+_vm._s(_vm.row.shopName)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }